import { Button, CircularProgress } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ImageHand from '../../../../assets/join-hands/bg.png'
import { useAuthRedirect } from '../../../../hooks/use-auth-redirect'
import { usePreloadedImage } from '../../../../hooks/use-preloaded-image'
import { useMainPageJoinHandsSectionStyles } from './main-page-join-hands-section.styles'

export const MainPageJoinHandsSection: React.FC = () => {
  const classes = useMainPageJoinHandsSectionStyles()
  const { authRedirectHandle } = useAuthRedirect()
  const { t } = useTranslation()
  const bgReady = usePreloadedImage(ImageHand)
  const [loaderMounted, setLoaderMounted] = React.useState(true)

  React.useEffect(() => {
    if (!bgReady) setLoaderMounted(true)
  }, [bgReady])

  const onLoaderTransitionEnd = (
    e: React.TransitionEvent<HTMLDivElement>
  ) => {
    if (e.target !== e.currentTarget) return
    if (e.propertyName !== 'opacity' || !bgReady) return
    setLoaderMounted(false)
  }

  return (
    <div className={classes.joinHandsSection}>
      <div
        className={[
          classes.sectionBgImage,
          bgReady && classes.sectionBgImageVisible,
        ]
          .filter(Boolean)
          .join(' ')}
        style={{ backgroundImage: `url(${ImageHand})` }}
      />
      {loaderMounted && (
        <div
          className={[
            classes.sectionBgLoader,
            bgReady && classes.sectionBgLoaderHidden,
          ]
            .filter(Boolean)
            .join(' ')}
          onTransitionEnd={onLoaderTransitionEnd}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      <div className={classes.joinHandsOverlay}></div>
      <div className={classes.joinHandsBlock}>
        <div className={classes.joinHandsText}>
          {t('mainPage.joinHands.text')}
        </div>
        <div className={classes.joinHandsBtnHolder}>
          <Button
            onClick={(e) => authRedirectHandle(e, '/donate', '/donate')}
            fullWidth
            variant="contained"
            size="medium"
            color="secondary"
          >
            {t('mainPage.joinHands.start')}
          </Button>
        </div>
      </div>
    </div>
  )
}
